import { isEmpty } from 'radash';
import { IngredientType, RecipeRelateIngredientsResponse, RecipeRelateResponse, RelateWithProductResponse } from '@modules/libs/graphql/generated/graphql';
import { IIngredientDetail, IRecipeDetail } from '@modules/recipes/domain/models/recipeDetail.model';
import { mapIngredientTypeToDomain } from '@shared/helpers/mapIngredientType.helper';
import { convertTimeToMinutes } from '@shared/utils/convertTime.utils';
export class RecipeEntityMapper {
  public static toDomain(recipeResponse: RecipeRelateResponse): IRecipeDetail {
    const {
      id,
      coverImageUrl,
      youtubeUrl,
      title,
      description,
      time,
      people,
      toPeople,
      cooking,
      ingredientImage,
      slugUrl,
      creator,
      recipeIngredient,
      recipeProduct
    } = recipeResponse;
    const ingredients = recipeIngredient ?? [];
    const products = recipeProduct?.filter(({
      product
    }) => product) ?? [];
    return {
      id,
      coverImg: coverImageUrl,
      coverVdo: youtubeUrl,
      title,
      description,
      cookingTime: `${convertTimeToMinutes(time)} นาที`,
      people: `${people} ${toPeople ? `- ${toPeople}` : ''} คน`,
      content: cooking,
      creator: {
        id: creator.id.toString(),
        name: creator.name,
        imageUrl: creator.imageUrl,
        slugUrl: creator.slugUrl
      },
      ingredients: {
        imageUrl: ingredientImage,
        list: this.ingredientEntityMapper(ingredients, products),
        total: ingredients.length + products.length
      },
      slugUrl: isEmpty(slugUrl) ? id.toString() : slugUrl
    };
  }
  private static ingredientEntityMapper(ingredientList: RecipeRelateIngredientsResponse[], productList: RelateWithProductResponse[]): IIngredientDetail[] {
    const mainIngredients = productList.map(({
      product,
      quantity,
      unit,
      linkoutUrl
    }): IIngredientDetail => {
      return {
        id: product.id.toString(),
        name: product.title,
        quantity,
        unit,
        brand: mapIngredientTypeToDomain(IngredientType.Product),
        //TODO: discuss with BE about type's meaning
        linkout: `/product/${isEmpty(linkoutUrl) ? product.id.toString() : linkoutUrl}`
      };
    });
    const ingredients = ingredientList.map(({
      ingredient,
      quantity,
      unit,
      ingredientType,
      linkoutUrl
    }): IIngredientDetail => {
      return {
        id: ingredient.id.toString(),
        name: ingredient.title,
        quantity,
        unit,
        brand: mapIngredientTypeToDomain(ingredientType),
        //TODO: discuss with BE about type's meaning
        linkout: `/product/${isEmpty(linkoutUrl) ? ingredient.id.toString() : linkoutUrl}`
      };
    });
    return [...mainIngredients, ...ingredients];
  }
}